import React from 'react';
import classNames from 'classnames';

const StringParagraph = ({
    children,
    small,
    className,
    space,
    strong = false
}: {
    children?: string;
    small?: boolean;
    className?: string;
    space?: boolean;
    strong?: boolean;
}): React.JSX.Element => {
    return (
        <p
            className={classNames(
                {
                    'paragraph--small': small,
                    'u-spacing-stack-none': !space,
                    'u-spacing-stack-m': space,
                    strong
                },
                className
            )}
        >
            {children}
        </p>
    );
};

export default StringParagraph;
